import React, { useEffect, useState, useContext } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { fetchGalleryImage } from 'src/actions/eventChat'
import ViewMessageContext from '../../ViewMessageContext'
import { Image } from 'antd'
import styles from './gallery-message.scss'

const GalleryMessage = props => {
  const dispatch = useDispatch()
  const { galleryContent } = props
  const [galleries, setGalleries] = useState([])
  const { onSetPreviewGalleries, onSetPreviewIndex } = useContext(ViewMessageContext)

  useEffect(() => {
    dispatch(
      fetchGalleryImage({
        galleryId: galleryContent.metadata.gallery_id,
        onSuccessCallback: res => {
          setGalleries(res.data.galleries)
        }
      })
    )
  }, [])

  return (
    <div className={styles['galleries-container']}>
      {galleries.map(gallery => {
        const gallery_images = gallery.gallery_image_uploads
        return (
          <div className={styles['gallery-item-wrapper']} key={gallery.id}>
            {gallery_images.map((img, index) => {
              const image_upload = img.image_upload
              if (index > 3) {
                return
              }
              if (index === 3 && gallery_images.length > 4) {
                return (
                  <div className={styles['img-wrapper']} key={img.id}>
                    <img className={styles['img-inner']} src={image_upload.medium_cropped_url} />
                    <div
                      className={styles['float-layer']}
                      onClick={() => {
                        onSetPreviewIndex(index)
                        onSetPreviewGalleries(gallery_images)
                      }}
                    >
                      All {gallery_images.length} Photos
                    </div>
                  </div>
                )
              }
              return (
                <Image
                  key={img.id}
                  width={210}
                  height={150}
                  rootClassName={styles['img-inner']}
                  src={image_upload.medium_cropped_url}
                  onClick={() => {
                    onSetPreviewIndex(index)
                    onSetPreviewGalleries(gallery_images)
                  }}
                  preview={{ visible: false }}
                />
              )
            })}
          </div>
        )
      })}
    </div>
  )
}

GalleryMessage.propTypes = {
  galleryContent: PropTypes.object.isRequired
}

export default GalleryMessage
